__turbopack_context__.v({
  "client_card": "home-module__YfYPQa__client_card",
  "client_card_background": "home-module__YfYPQa__client_card_background",
  "client_card_content": "home-module__YfYPQa__client_card_content",
  "client_card_description": "home-module__YfYPQa__client_card_description",
  "client_card_title": "home-module__YfYPQa__client_card_title",
  "client_card_wrapper": "home-module__YfYPQa__client_card_wrapper",
  "content": "home-module__YfYPQa__content",
  "content_block_title": "home-module__YfYPQa__content_block_title",
  "preview__background_cover": "home-module__YfYPQa__preview__background_cover",
});
